<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增预算项目' : '编辑预算项目'"
    :enableDrag="true"
    width="500px"
    @close="cancel"
  >
    <dynamic-form
      :formConfig="formConfig"
      labelWidth="120px"
      v-model="form"
      @submit="doSubmit"
      @cancelForm="cancel"
      ref="pageForm"
    ></dynamic-form>
  </drag-dialog>
</template>

<script>
import { addProjectBudget, editProjectBudget } from '@/api/basic/budgetItem';
import DragDialog from "@/components/DragDialog";
import "@/components/dynamic-form";
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      loading: false,
      dialog: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "text",
            maxlength: "50",
            showWordLimit: true,
            key: "code",
            label: "预算项目代码",
            value: "",
            rules: [
              {
                required: true,
                message: "预算项目代码生成失败",
                trigger: "blur"
              },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "预算项目代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "text",
            maxlength: "100",
            showWordLimit: true,
            key: "name",
            label: "预算项目名称",
            value: "",
            rules: [
              {
                required: true,
                message: "预算项目名称不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "textarea",
            maxlength: "200",
            showWordLimit: true,
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      }
    };
  },
  methods: {
    cancel() {
      this.resetForm();
    },
    doSubmit(val) {
      this.form = val;
      if (this.isAdd) {
        this.doAdd();
      } else this.doEdit();
    },
    doAdd() {
      addProjectBudget(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "添加成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    doEdit() {
      editProjectBudget(this.form)
        .then(res => {
          this.resetForm();
          this.$notify({
            title: "修改成功",
            type: "success",
            duration: 2500
          });
          this.loading = false;
          this.supThis.dataTableInit();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    resetForm() {
      this.dialog = false;
      this.$refs.pageForm.resetForm();
      this.form = {}
    }
  }
};
</script>

<style scoped>
</style>
